import React, { useEffect, useRef } from 'react'

function HowItWorks() {
  const stepRefs = useRef([])

  useEffect(() => {
    const observers = stepRefs.current.map((ref) => {
      if (!ref) return null
      
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible')
            }
          })
        },
        { threshold: 0.2 }
      )
      
      observer.observe(ref)
      return observer
    })

    return () => {
      observers.forEach((observer) => observer?.disconnect())
    }
  }, [])

  const steps = [
    {
      number: '1',
      title: 'Registrierung & Interessen',
      description: 'Registrierung in wenigen Schritten und Interessen auswählen für passende Kampagnen. Die App führt dich durch den einfachen Setup-Prozess.'
    },
    {
      number: '2',
      title: 'Kampagnen-Slots',
      description: '5 tägliche Slots: 09:00, 12:00, 15:00, 18:00, 21:00. Benachrichtigungen zu den Slot-Zeiten. Jeder Slot kann einmal täglich genutzt werden. Jeder Slot ist 2 Stunden aktiv (1 Stunde vor bis 1 Stunde nach der Slot-Zeit).'
    },
    {
      number: '3',
      title: 'Kampagnen ansehen',
      description: '5-Sekunden-Timer: Die Kampagne startet automatisch. X-Button erscheint nach 2 Sekunden (bei 3 verbleibenden Sekunden) an zufälliger Position. Manuelles Schließen nach mindestens 5 Sekunden. Belohnung: 0,067€ pro vollständig angesehener Kampagne.'
    },
    {
      number: '4',
      title: 'Belohnungen',
      description: '0,067€ pro Kampagne (feste Belohnung). Ganze 10 € pro Monat möglich (5 Kampagnen/Tag × 30 Tage). Belohnungen werden sofort gutgeschrieben. Auszahlung über das Belohnungssystem.'
    }
  ]

  return (
    <section id="how-it-works" className="how-it-works section">
      <div className="container">
        <h2 className="section-title">Wie funktioniert spotx?</h2>
        <p className="section-subtitle">
          In 4 einfachen Schritten zu deinen ersten Belohnungen
        </p>
        <div className="steps-container">
          {steps.map((step, index) => (
            <div
              key={index}
              className="step"
              ref={(el) => (stepRefs.current[index] = el)}
            >
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default HowItWorks
